import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { FeatureSnapshot } from 'components/FeatureSnapshot';
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  FeatureSnapshot,
  React
};